import { Component, OnInit } from '@angular/core';

import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class AppComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
